module.exports = __webpack_public_path__ + "img/filezilla-key.01f15d83.png";